import { hasAnyGroupWithMembers, hasNonHiddenGroup } from "src/util/group";

export const showGroup = (groups) => {
  // some type groupings can contain all groups with no members
  // we don't display teams with no members, so don't display title too
  return hasAnyGroupWithMembers(groups) || hasNonHiddenGroup(groups);
};
